import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABand({
  title = "Ready to Discuss Your Situation?",
  text = "Book a confidential consultation with our team and take the next step with confidence.",
  image = "/images/consult.jpg",
}) {
  return (
    <section className="relative overflow-hidden bg-navy">
      {image && (
        <img
          src={image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
      )}
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(11,25,44,0.97) 0%, rgba(11,25,44,0.93) 50%, rgba(11,25,44,0.82) 100%)" }} />
      <div className="container-x relative flex flex-col items-start gap-6 py-16 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <h2 className="font-serif text-3xl font-semibold text-white sm:text-4xl">{title}</h2>
          <p className="mt-3 text-base leading-relaxed text-slate-200">{text}</p>
        </div>
        <Link to="/book-consultation" data-testid="cta-band-book-btn" className="btn-gold shrink-0">
          Book a Consultation <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
}
